/**
 * @file 首页
 * @author wangzhuang
 */

import {
    GET_PAID_ATTEST_LIST,
    GET_FLASH_NUM
} from '../actions/ActionTypes';
const initialState = {
    paidAttestList: {},
    flashNum: 0
};
export function myAttestReducer(state = initialState, action) {
    switch (action.type) {
        case GET_PAID_ATTEST_LIST:
            return {
                ...state,
                paidAttestList: action.data?.data || {}
            };
        case GET_FLASH_NUM:
            return {
                ...state,
                flashNum: action.data.data.count || 0
            };
        default:
            return state;
    }
}